import styles from "./notices-table.module.css";

import { Flex, Tooltip } from "antd";

import TaskIcon from "@/icons/TaskIcon";
import CubIcon from "@/icons/CubIcon";
import StarIcon from "@/icons/StarIcon";
import FolderOpenIcon from "@/icons/FolderOpenIcon";
import AdminIcon from "@/icons/AdminIcon";
import DotCircleFull from "@/icons/DotCircleFull";
import DotCircleEmpty from "@/icons/DotCircleEmpty";

import CustomLink from "@/components/ui/CustomLink";

import { formateISODateToMoment } from "@/utils";

export const COLUMN_LABELS = {
  is_read: "",
  object_type: "Раздел",
  object: "Название",
  unit: "Рабочая группа",
  created_at: "Дата, время",
};

const getIcon = (type) => {
  switch (type) {
    case "task":
      return <TaskIcon />;
    case "object":
      return <CubIcon />;
    case "group":
      return <StarIcon />;
    case "file":
      return <FolderOpenIcon />;
    case "system":
      return <AdminIcon />;
    default:
      return null;
  }
};

export const createColumns = (onReadNotice) => [
  {
    title: COLUMN_LABELS.is_read,
    dataIndex: "is_read",
    key: "is_read",
    width: 40,
    sorter: {
      compare: (a, b) => a.is_read - b.is_read,
    },
    render: (is_read) =>
      is_read ? (
        <div className={`${styles.mail_btn}`}>
          <DotCircleEmpty />
        </div>
      ) : (
        <div className={styles.mail_btn}>
          <DotCircleFull style={{ color: "#E66A25" }} />
        </div>
      ),
  },
  {
    title: COLUMN_LABELS.object_type,
    dataIndex: "object_type",
    key: "object_type",
    width: 110,
    ellipsis: { showTitle: true },
    sorter: {
      compare: (a, b) =>
        (a.object_type?.object_type_display || "").localeCompare(
          b.object_type?.object_type_display || "",
        ),
    },
    render: (_, item) => (
      <Flex align="center" gap={3} className={styles.type_tag}>
        {getIcon(item.object_type?.object_type_key)}
        {item.object_type?.object_type_display}
      </Flex>
    ),
  },
  {
    title: COLUMN_LABELS.object,
    dataIndex: "object",
    key: "object",
    width: 200,
    ellipsis: true,
    sorter: {
      compare: (a, b) =>
        (a.object?.object_name || "").localeCompare(
          b.object?.object_name || "",
        ),
    },
    render: (_, item) => (
      <Tooltip placement="bottomLeft" title={item.object?.object_name}>
        {item.object?.object_link ? (
          <CustomLink
            to={item.object?.object_link}
            color="#0066A6"
            onClick={(e) =>
              onReadNotice(
                item.events
                  .filter(({ is_read }) => !is_read)
                  .map(({ uuid }) => uuid),
              )
            }
          >
            {item.object_type?.object_type_key === "task" &&
              item.object?.object_number &&
              `№${item.object?.object_number} `}
            {item.object?.object_name}
          </CustomLink>
        ) : (
          <span>{item.object?.object_name}</span>
        )}
      </Tooltip>
    ),
  },
  {
    title: COLUMN_LABELS.unit,
    dataIndex: "unit",
    key: "unit",
    width: 150,
    ellipsis: true,
    sorter: {
      compare: (a, b) => (a.unit?.name || "").localeCompare(b.unit?.name || ""),
    },
    render: (_, item) => (
      <Tooltip placement="bottomLeft" title={item.unit?.name}>
        {item.unit?.name}
      </Tooltip>
    ),
  },
  {
    title: COLUMN_LABELS.created_at,
    dataIndex: "created_at",
    key: "created_at",
    width: 130,
    defaultSortOrder: "descend",
    sorter: {
      compare: (a, b) => (a.created_at || "").localeCompare(b.created_at || ""),
    },
    render: (_, item) => <>{formateISODateToMoment(item.created_at)}</>,
  },
];
